<template>
  <div class="content">
    <div class="title">{{ $t('common.step.1') }}</div>
    <div class="box_inner">
      <div class="title"><span style="color: red">*</span> {{ $t('common.step.txt.1') }}</div>
      <el-select
          v-model="valueType"
          :placeholder="$t('common.please.select')"
          style="width: 200px;margin-top: 10px;"
          @change="handleClickSelectGroupType"
      >
        <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
        />
      </el-select>
      <div class="tips" v-if="valueType===1">
        <div>{{ $t('common.step.tip') }}</div>
        <div style="display: flex;flex-direction: column;">
          <div>{{ $t('common.step.tip.1') }}{{ $t('common.step.tip.2') }}</div>
        </div>
      </div>
      <div class="checkout_type">
        <div class="title"><span style="color: red">*</span> {{ $t('common.step.select.type') }}</div>
        <div class="select_box">
          <div :class="[item.isSelect?'item_box_true':'item_box']" @click="handleClickSelect(item)"
               v-for="item in groupSendList" :key="item.key">
            <div style="display: flex">
              <div>
                <img :src="item.img" style="width: 100px;height: 100px;">
              </div>
              <div
                  style="margin-left: 20px;display: flex;align-items: flex-start;flex-direction: column;justify-content: center">
                <div class="item_title">{{ item.name }}</div>
                <div class="des">{{ item.des }}</div>
                <div v-if="item.key===2">
                  <span class="s_f">{{ $t('write.send.all.email') }}&nbsp;&nbsp;</span>
                  <span class="s_f" style="color: red;cursor: pointer;text-decoration: underline;" @click="toBuy">
                    {{ userDataInformation?.freeEdmNum ? userDataInformation?.freeEdmNum : 0 }}
                    {{ $t('common.ph23') }}
                  </span>
                </div>
              </div>
            </div>
            <div v-if="item.isSelect">
              <el-icon style="color: #448ef7;" size="22">
                <CircleCheckFilled/>
              </el-icon>
            </div>
          </div>
        </div>
      </div>
      <div style="height: 65px;width: 100%;"></div>
    </div>
  </div>
</template>

<script setup>
import {computed, nextTick, onMounted, ref, watch} from "vue";
import {i18n} from "@/lang";
import img1 from "@/assets/Marketing/1@2x.png"
import img2 from "@/assets/Marketing/2@2x.png"
import {useStore} from "vuex";
import {useRouter} from "vue-router";
import sessionStore from "@/utils/sessionStore";

const store = useStore();
const router = useRouter();

const props = defineProps({
  currentMassEmailObj: {
    type: Object,
    default: () => ({})
  }
})

const options = [
  {
    value: 1,
    label: i18n.global.t('common.step.txt.select.1'),
  },
  {
    value: 2,
    label: i18n.global.t('common.step.txt.select.2'),
  },
  {
    value: 3,
    label: i18n.global.t('common.step.txt.select.3'),
  },
  {
    value: 4,
    label: i18n.global.t('common.step.txt.select.4'),
  },
  {
    value: 5,
    label: i18n.global.t('common.step.txt.select.5'),
  },
  {
    value: 6,
    label: i18n.global.t('common.step.txt.select.6'),
  },
  {
    value: 7,
    label: i18n.global.t('common.step.txt.select.7'),
  },
  {
    value: 8,
    label: i18n.global.t('common.step.txt.select.8'),
  },
]

// 选择的任务营销类型
const valueType = ref("")

const getValueType = (type) => {
  const item = options.find(_ => _.value === type)
  return item ? item.value : ''
}

const groupSendList = ref([
  {
    key: 1,
    img: img1,
    name: i18n.global.t('sending.customer.option.massMailType.system'),
    des: i18n.global.t('common.step.des.1'),
    isSelect: false
  },
  {
    key: 2,
    img: img2,
    name: i18n.global.t('sending.customer.option.massMailType.smart'),
    des: i18n.global.t('common.step.des.2'),
    isSelect: false
  }
])
const selectType = ref(sessionStore.get("STEP_0_SELECT_WAYS") || "")
const handleClickSelect = (item) => {
  console.log(item, 'item')
  const {key} = item
  selectType.value = key;
  updateSelected(key)
  sessionStore.set("STEP_0_SELECT_WAYS", key)
}

const openNewTab = (path, query = {}) => {
  const routeInfo = router.resolve({path, query});
  window.open(routeInfo.href, '_blank');
};

const userDataInformation = computed(() => store.state.cloud.userDataInformation)
const toBuy = () => {
  //   购买edm
  openNewTab('/personal/edmDetails')
}
const handleClickSelectGroupType = (val) => {
  sessionStore.set("STEP_0_SELECT_TYPE", val)
}

onMounted(async () => {
  await store.dispatch("cloud/queryByUserIdApis")
  await nextTick()
  const val = sessionStore.get("STEP_0_SELECT_WAYS") ?? props.currentMassEmailObj?.massMailType
  console.log(val, 'valvvvvvv')
  if (val) {
    selectType.value = val
    updateSelected(val)
  } else {
    selectType.value = ""
  }
  const type = sessionStore.get("STEP_0_SELECT_TYPE") ?? props.currentMassEmailObj?.massMarketType
  valueType.value = getValueType(type)
})

watch(
    () => props.currentMassEmailObj?.massMailType,
    async (newVal) => {
      if (newVal != null) {
        // 等待 groupSendList 渲染完成
        await nextTick()
        selectType.value = newVal
        updateSelected(newVal)
      }
    },
    {deep: true, immediate: false}
)

watch(() => props.currentMassEmailObj?.massMarketType, async (newVal) => {
      if (newVal != null) {
        // 等待 groupSendList 渲染完成
        await nextTick()
        valueType.value = getValueType(newVal)
      }
    }, {deep: true, immediate: false}
)

function updateSelected(data) {
  try {
    groupSendList.value.forEach(obj => {
      obj.isSelect = obj.key === data
    })
  } catch (e) {
    console.log(e)
  }
}

defineExpose({
  valueType,
  selectType,
})

</script>

<style lang="less" scoped>
.content {
  margin: 0px auto;
  height: 100%;
  width: 900px;
  //background: yellow;
  text-align: left;

  .title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #000000;
  }

  .box_inner {
    padding: 20px;
    margin-top: 10px;
    max-height: calc(100vh - 250px);
    overflow: scroll;
    background: #FAFAFA;
  }

  .tips {

    display: flex;
    margin-top: 10px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #535659;
  }

  .checkout_type {
    margin-top: 36px;
    box-sizing: border-box;

    .item_box {
      cursor: pointer;
      padding: 10px 20px;
      margin-top: 10px;
      display: flex;
      background: #FFFFFF;
      border-radius: 4px;
      height: max-content;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .item_box_true {
      height: max-content;
      cursor: pointer;
      padding: 10px 20px;
      margin-top: 10px;
      display: flex;
      background: #EFF7FF;
      border: 1px solid #1890FF;
      border-radius: 4px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .item_title {
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #1890FF;
    }

    .des {
      margin-top: 6px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #535659;
    }

    .s_f {
      font-size: 14px;
      color: #535659;
    }
  }
}

:deep(.ant-steps-item-process) {
  :deep(.ant-steps-item-icon) {
    background-color: #1890FF !important;
    border-color: #1890FF !important;
  }
}

</style>